<template>
    <ChatAgentToolFrame is-actionable class="p-0">
        <BaseLink :href="`/role-play/summary/${rolePlayHashid}/`" class="flex items-center justify-between p-6 rounded-3xl active text-valence-primary-500" preserve-scroll>
            <p class="nadia-chat">View Role Play Recap</p>
            <i class="bi bi-file-text text-2xl/none relative" aria-hidden="true">
                <i class="bi bi-stars text-sm/none absolute rounded-full bg-white -right-1 -top-1" aria-hidden="true"></i>
            </i>
        </BaseLink>
    </ChatAgentToolFrame>
</template>

<script setup>
import BaseLink from "~vue/router/BaseLink.vue";
import { computed } from "vue";

import ChatAgentToolFrame from "./ChatAgentToolFrame.vue";

const props = defineProps({
    data: { type: Object, required: true },
    messageId: { type: Number, required: true },
    lineIdx: { type: Number, required: true },
});

const rolePlayHashid = computed(() => props.data.action_params?.role_play_hashid ?? props.data.action_params?.role_play_id);
</script>
